export const STUDENT_DOCUMENT_TYPES = Object.freeze({
  NONE: 0,
  PASSPORT_STYLE_PHOTO: 1,
  DRIVER_LICENCE: 2,
  PASSPORT: 3,
  USI_SUPPORTING_DOCUMENT: 4,
  STAFF_SIGNATURE: 5,
  STUDENT_SIGNATURE: 6,
  OTHER_ACCEPTABLE_PHOTO_ID: 7,
  MEDICARE_CARD: 8,
  CENTRELINK_HEALTH_CARE_CARD: 9,
  NEW_ZEALAND_PASSPORT: 10,
  AUSTRALIAN_BIRTH_CERTIFICATE: 11,
  AUSTRALIAN_CITIZENSHIP_CERTIFICATE: 12,
  VEVO_CHECK: 13,
});

export const STUDENT_DOCUMENT_DEFINITIONS = Object.freeze([
  { id: STUDENT_DOCUMENT_TYPES.PASSPORT_STYLE_PHOTO, name: "Passport Style Photo", key: "photo" },
  { id: STUDENT_DOCUMENT_TYPES.DRIVER_LICENCE, name: "Driver Licence", key: "licence" },
  { id: STUDENT_DOCUMENT_TYPES.PASSPORT, name: "Passport", key: "passport" },
  { id: STUDENT_DOCUMENT_TYPES.USI_SUPPORTING_DOCUMENT, name: "USI Supporting Document", key: "usi" },
  { id: STUDENT_DOCUMENT_TYPES.STAFF_SIGNATURE, name: "Staff Signature", key: "staff-signature" },
  { id: STUDENT_DOCUMENT_TYPES.STUDENT_SIGNATURE, name: "Student Signature", key: "student-signature" },
  { id: STUDENT_DOCUMENT_TYPES.OTHER_ACCEPTABLE_PHOTO_ID, name: "Other Acceptable Photo ID", key: "other-photo-id" },
  { id: STUDENT_DOCUMENT_TYPES.MEDICARE_CARD, name: "Medicare Card", key: "medicare-card" },
  { id: STUDENT_DOCUMENT_TYPES.CENTRELINK_HEALTH_CARE_CARD, name: "Centrelink Health Care Card", key: "centrelink-card" },
  { id: STUDENT_DOCUMENT_TYPES.NEW_ZEALAND_PASSPORT, name: "New Zealand Passport", key: "new-zealand-passport" },
  { id: STUDENT_DOCUMENT_TYPES.AUSTRALIAN_BIRTH_CERTIFICATE, name: "Australian Birth Certificate", key: "birth-certificate" },
  { id: STUDENT_DOCUMENT_TYPES.AUSTRALIAN_CITIZENSHIP_CERTIFICATE, name: "Australian Citizenship Certificate", key: "citizenship-certificate" },
  { id: STUDENT_DOCUMENT_TYPES.VEVO_CHECK, name: "VEVO Check", key: "vevo-check" },
]);

export const STUDENT_DOCUMENT_ACCEPT = ".jpg,.jpeg,.png,.pdf";
export const STUDENT_DOCUMENT_MAX_BYTES = 10 * 1024 * 1024;
